import { Swiper as _Swiper, SwiperSlide as _SwiperSlide } from "swiper/react";
import {
  Navigation as _Navigation,
  Pagination as _Pagination,
  EffectCoverflow as _EffectCoverflow,
} from "swiper";

export const Swiper = _Swiper;
export const SwiperSlide = _SwiperSlide;
export const EffectCoverflow = _EffectCoverflow;
export const Navigation = _Navigation;
export const Pagination = _Pagination;
